var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99391 17.0807L6.95703 14.0439L7.82724 13.1736L9.36891 14.6866V5.30031L7.83516 6.82114L6.96495 5.95094L10.0018 2.91406L13.0387 5.95094L12.1606 6.84198L10.6187 5.30823V14.6866L12.1606 13.1736L13.0306 14.0439L9.99391 17.0807Z",
    fill: "#189FAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/height.b8710112983dc0d0e44431d9d2b37d9a.svg";
export { ForwardRef as ReactComponent };